import React, { type SyntheticEvent } from 'react';
import { Sidebar } from '@atlassian/eoc-team-dashboard';
import { useEocFeedbackCollector } from '@atlassian/jira-eoc-feedback-collector/src/index.tsx';
import { GlobalContextContainer } from '@atlassian/jira-eoc-global-context/src/index.tsx';
import { ConsolidatedStateError } from '@atlassian/jira-eoc-tenant-info/src/ui/error/index.tsx';
import { ConsolidatedStateWrapper } from '@atlassian/jira-eoc-tenant-info/src/ui/index.tsx';
import { SidebarErrorBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/error-boundary/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import { fireUIAnalytics, type UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';

export const TeamDashboardSidebar = () => {
	const { openEocFeedbackCollector } = useEocFeedbackCollector();

	const onFeedbackButtonClick = (_: SyntheticEvent, analyticEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticEvent, 'eocGiveFeedbackButton');
		openEocFeedbackCollector();
	};

	return (
		<>
			<SidebarRenderStart />
			<SidebarErrorBoundary
				teamName="alexstrasza"
				packageName="jiraNavigationAppsSidebarEocTeamDashboard"
				id="jiraNavigationAppsSidebarEocTeamDashboardSidebar"
			>
				<GlobalContextContainer teamName="alexstrasza" packageName="jiraEocTeamDashboard">
					<ConsolidatedStateWrapper errorComponent={<ConsolidatedStateError />}>
						<Sidebar onFeedbackButtonClick={onFeedbackButtonClick} />
					</ConsolidatedStateWrapper>
				</GlobalContextContainer>
			</SidebarErrorBoundary>
			{!__SERVER__ && <SidebarReady id={SIDEBAR_ID.EOC_OPERATIONS} />}
		</>
	);
};
